<script setup>
import { gsap } from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import { useMainStore } from '~/store'

const store = useMainStore()

const { lenis } = useLenis()

gsap.registerPlugin(ScrollToPlugin)

const scrollToElementById = (id) => {
  const element = document.getElementById(id)
  if (element && lenis.value) {
    const top = element.getBoundingClientRect().top + window.scrollY - 50
    gsap.to(window, {
      scrollTo: { y: top, autoKill: false },
      duration: 1.7,
      ease: 'back.out(0.7)',
    })
  }
}

const closeMenu = () => {
  store.open = !store.open
}

const sections = ref({
  chiSiamo: false,
  organizzazione: false,
  welfare: false,
  selezione: false,
  talentDay: false,
})

onMounted(() => {
  sections.value.chiSiamo = !!document.getElementById('chi-siamo')
  sections.value.organizzazione = !!document.getElementById('organizzazione')
  sections.value.welfare = !!document.getElementById('welfare')
  sections.value.selezione = !!document.getElementById('selezione')
  sections.value.talentDay = !!document.getElementById('talent-day')
})
</script>

<template>
  <div class="header__wrapper">
    <header ref="header" class="main-menu row-40-20">
      <!-- Navigation -->
      <nav class="main-menu__wrap">
        <div class="main-menu__left">
          <!-- Navigation Logo -->
          <div class="anim-opacity">
            <img
              src="@/assets/img/ico/pixartprinting.svg"
              alt="Pixartprinting"
              class="logo-pixart"
              @click="scrollToElementById('start'), closeMenu()"
            />
          </div>
        </div>

        <div class="main-menu__center">
          <!-- Navigation Main Links -->
          <div
            v-if="sections.chiSiamo"
            class="main-menu__section-link text-4b show-for-large"
          >
            <nuxt-link
              class="underline-animation pixart-text"
              @click="scrollToElementById('chi-siamo')"
            >
              {{ $t('nav.chiSiamo') }}
            </nuxt-link>
          </div>
          <div
            v-if="sections.organizzazione"
            class="main-menu__section-link text-4b show-for-large"
          >
            <nuxt-link
              class="underline-animation pixart-text"
              @click="scrollToElementById('organizzazione')"
            >
              {{ $t('nav.organizzazione') }}
            </nuxt-link>
          </div>
          <div
            v-if="sections.welfare"
            class="main-menu__section-link text-4b show-for-large"
          >
            <nuxt-link
              class="underline-animation pixart-text"
              @click="scrollToElementById('welfare')"
            >
              {{ $t('nav.welfare') }}
            </nuxt-link>
          </div>
          <div
            v-if="sections.selezione"
            class="main-menu__section-link text-4b show-for-large"
          >
            <nuxt-link
              class="underline-animation pixart-text"
              @click="scrollToElementById('selezione')"
            >
              {{ $t('nav.selezione') }}
            </nuxt-link>
          </div>
          <div
            v-if="sections.talentDay"
            class="main-menu__section-link text-4b show-for-large last"
          >
            <nuxt-link
              class="underline-animation pixart-text"
              @click="scrollToElementById('talent-day')"
            >
              {{ $t('nav.talentDay') }}
            </nuxt-link>
          </div>
        </div>

        <div class="main-menu__right">
          <nuxt-link
            :to="$t('common.recruitingLink')"
            target="_blank"
            class="main-menu__section-link text-4b show-for-large lavora-con-noi pixart-text"
          >
            {{ $t('common.entraNelTeam') }}
          </nuxt-link>
          <NavigationHamburger
            class="hide-for-large hamburger-pixart"
            :open="store.open"
            @toggle="store.toggleOverlay"
          />
        </div>
        <div :class="{ 'is-visible': store.open }" class="menu-section-mobile">
          <div class="content">
            <div
              v-if="sections.chiSiamo"
              class="main-menu__section-link pixart-text"
            >
              <nuxt-link @click="scrollToElementById('chi-siamo'), closeMenu()">
                {{ $t('nav.chiSiamo') }}
              </nuxt-link>
            </div>
            <div
              v-if="sections.organizzazione"
              class="main-menu__section-link pixart-text"
            >
              <nuxt-link
                @click="scrollToElementById('organizzazione'), closeMenu()"
              >
                {{ $t('nav.organizzazione') }}
              </nuxt-link>
            </div>
            <div
              v-if="sections.welfare"
              class="main-menu__section-link pixart-text"
            >
              <nuxt-link @click="scrollToElementById('welfare'), closeMenu()">
                {{ $t('nav.welfare') }}
              </nuxt-link>
            </div>
            <div
              v-if="sections.selezione"
              class="main-menu__section-link pixart-text"
            >
              <nuxt-link @click="scrollToElementById('selezione'), closeMenu()">
                {{ $t('nav.selezione') }}
              </nuxt-link>
            </div>
            <div
              v-if="sections.talentDay"
              class="main-menu__section-link pixart-text"
            >
              <nuxt-link
                @click="scrollToElementById('talent-day'), closeMenu()"
              >
                {{ $t('nav.talentDay') }}
              </nuxt-link>
            </div>
          </div>
        </div>
      </nav>
    </header>
  </div>
</template>

<script>
export default {
  name: 'NavigationHeader',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
